//@ts-nocheck
import { useState } from 'react';
import type { NextPage } from 'next';
import Link from 'next/link';
import Image from 'next/image';
import { BailetsBlock } from '../../ModalCopy.styles';
import { CloseVideoIcon, LogoMartins } from '@assets/svgs';
import { CWriting } from '@data/copywriting';

type BreitlingProps = {
  isClosed?: () => void;
  showImg?: boolean | string;
  showMedia?: boolean | string;
};

export const Rollsroycespectre = ({
  isClosed,
  showImg,
  showMedia
}: BreitlingProps) => {
  return (
    <>
      <BailetsBlock>
        <CloseVideoIcon
          animation="closeIcon"
          color="#000"
          isActive={isClosed}
        />
        <LogoMartins
          width={70}
          height={65}
          color="rgba(0,0,0,0.5)"
          animation="mansion"
        />

        <h3>ROLLS ROYCE</h3>
        <span style={{ marginBottom: '25px' }}>Rolls Royce Spectre</span>
        {showImg && <Image src={showImg} width={1480} height={825} alt="" />}
        {showMedia && (
          <video
            controlsList="nodownload"
            controls={true}
            playsInline
            muted
            autoPlay
            loop
          >
            <source src={showMedia} type="video/mp4" />
          </video>
        )}
        <h3 style={{ marginTop: '25px' }}>{CWriting.copyWriting[5].title1}</h3>
        <h3>{CWriting.copyWriting[5].title2}</h3>
        <br />
        <br />
        <p style={{ width: '100%' }}>
          <b>Life is beyond existence and time. </b>
          <br />
          <br />
          The Rolls-Royce Spectre is here. The world's first drastic-luxury
          electric vehicle. A masterpiece of engineering and design, the Spectre
          redefines what it means to drive in elegance. Seamlessly combining our
          century-old heritage with groundbreaking technology, it offers a
          whisper-quiet, zero-emission journey.
        </p>
        <p style={{ width: '100%' }}>
          “YOU ARE LUXURY. YOU ARE THE DIAMOND OF YOUR PERFECTION!”
        </p>
        <p style={{ width: '100%' }}>
          <b>The silent velocity.</b>
        </p>
        <p style={{ width: '100%' }}>
          The light speed and the momentum of an unexplainable vibration.
        </p>
        <p style={{ width: '100%' }}>
          <b>FEEL IT.</b> The cosmic future is now.
        </p>
        <p style={{ width: '100%' }}>
          The king of electricity and silence and the most powerful engine in
          the world without a sound.
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>We present the unsound breeze on wheels.</b>
        </p>
        <p style={{ width: '100%' }}>
          Rolls-Royce, the epitome of opulence and engineering excellence, has
          unveiled the Spectre as its inaugural fully electric vehicle (EV)!
          This incredible new product is proof positive of the company's
          dedication to sustainability while maintaining its reputation for
          unparalleled luxury. The Spectre is a strategic response to a changing
          automotive landscape, where electrification is becoming both a
          regulatory necessity and a market demand – and Rolls-Royce is leading
          the way!
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>The Campaign</b>
        </p>
        <p style={{ width: '100%' }}>
          <b>1. Tagline Development</b>
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          "The Future of Luxury, Electrified."
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          "Silent Power, Timeless Elegance."
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          "Electric. Exalted. Delicate."
        </p>
        <p style={{ width: '100%' }}>
          <b>2. Headline Concepts</b>
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          "Where Heritage Meets Horizon: The Rolls-Royce Spectre."
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          "The Art of Driving, Reinvented for a Greener Tomorrow."
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          "Luxury Has Evolved. Welcome to the Rolls-Royce Spectre."
        </p>

        <p style={{ width: '100%' }}>
          <b>3. Landing Page</b>
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          <b>Header:</b> "The Dawn of Electric Luxury."
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          <b>Body:</b> "Introducing the Rolls-Royce Spectre—the world’s first
          ultra-luxury electric vehicle. A masterpiece of engineering and
          design, the Spectre redefines what it means to drive in elegance.
          Seamlessly combining our century-old heritage with groundbreaking
          technology, it offers a whisper-quiet, zero-emission journey. This is
          not just an electric vehicle; it is the Rolls-Royce of electric
          vehicles."
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          <b>CTA:</b> "Discover the Spectre—schedule your bespoke consultation
          today."
        </p>

        <p style={{ width: '100%' }}>
          <b>4. Social Media</b>
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          <b>Instagram Post:</b> Image Caption: "Crafted to perfection, driven
          by innovation. The Spectre—a new chapter in the Rolls-Royce story.
          🌌⚡ #RollsRoyceSpectre #ElectricLuxury"
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          <b>LinkedIn Post:</b> "We believe luxury should evolve with the times.
          That’s why we’re proud to introduce the Spectre—our first fully
          electric vehicle. Discover how we’ve combined zero-emission technology
          with timeless craftsmanship to redefine the future of luxury."
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          <b>Twitter Post:</b> "Heritage meets the horizon. The Rolls-Royce
          Spectre is here—our first fully electric luxury vehicle. Silent.
          Powerful. Visionary. ⚡ #RollsRoyceSpectre"
        </p>

        <p style={{ width: '100%' }}>
          <b>5. Email Campaign</b>
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          <b>Subject Line:</b> "Discover the Spectre: Luxury Goes Electric"
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          <b>Boby:</b>
          <br /> "Dear [%name%],
          <br />
          <br />
          The Rolls-Royce Spectre is more than an electric vehicle; it is a
          masterpiece of innovation and artistry. With its whisper-quiet
          performance and impeccable design, it is the pinnacle of sustainable
          luxury. Be among the first to experience the dawn of electric
          Rolls-Royce.
          <br />
          Schedule your bespoke consultation today and step into the future of
          driving.
          <br />
          <br />
          <br />
          Warm regards,
          <br />
          <br />
          [%name%]
          <br />
          Rolls-Royce Motor Cars"
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          <b>CTA:</b> "Book Your Spectre Consultation Now"
        </p>

        <p style={{ width: '100%' }}>
          <b>6. Video Script</b>
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          <b>Title:</b> "The Rolls-Royce Spectre: Silent Revolution"
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          <b>Opening Scene:</b> A serene landscape at dawn. The Spectre glides
          silently along a winding road, the sunlight reflecting off its sleek
          body.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          <b>Voiceover:</b> "In a world where silence speaks volumes,
          Rolls-Royce redefines luxury. The Spectre—the first electric vehicle
          in our storied legacy."
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          <b>Closing Scene:</b> The Spectre parked under a starry sky, its
          illuminated grille glowing softly.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          <b>Voiceover:</b> "The future of luxury is here. The Rolls-Royce
          Spectre."
        </p>
        <p style={{ width: '100%' }}>
          <b>The Message</b>
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          The Rolls-Royce Spectre is so much more than just a car – it's an
          incredible experience! The Spectre represents the absolute pinnacle of
          sustainable luxury, blending cutting-edge electric technology with the
          bespoke craftsmanship synonymous with Rolls-Royce.
        </p>
        <p style={{ width: '100%' }}>
          <b>Conclusion</b>
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          Spectre is so much more than just another electric vehicle. It's a
          shining symbol of how a century-old luxury brand can boldly embrace
          the future while still staying true to its core values. By redefining
          the standards of luxury in the electric age, Rolls-Royce has done more
          than meet market demands – they've paved the way for a sustainable,
          luxurious future!
        </p>
      </BailetsBlock>
    </>
  );
};
